<template>
  <DropDownModular
    :options="options"
    :selected="value"
    @updateSelected="$emit('selectZoom', $event)"
  >
    <template #head>
      <TText :text="getPercentageString(value)" />
    </template>
  </DropDownModular>
</template>
<script>
import DropDownModular from '@/components/WorkPackageWIP/DropDownModular.component.vue';

  export default {
    props: [
      'value'
    ],

    components: {
      DropDownModular,
    },

    data: () => ({
      values: [
        1.2,
        1.1,
        1,
        0.8,
        0.6,
        0.4,
        0.3,
        0.2,
        0.1,
        0.05,
        0.02,
      ],
    }),

    computed: {
      options() {
        let options = [];
        this.values.forEach((val) => {
          options.push({text: this.getPercentageString(val), id: val, })
        });

        return options;
      },
    },

    methods: {
      getPercentageString(value) {
        return `${Math.trunc(Math.round(value * 100))}%`;
      },
    },
  }
</script>
<style>
</style>
